"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyWeightsIngestedSchema = exports.SurveyWeightsUpdatedSchema = void 0;
const enums_1 = require("./enums");
const zod_1 = require("zod");
exports.SurveyWeightsUpdatedSchema = zod_1.z.object({
    type: zod_1.z.literal(enums_1.MessageType.SurveyWeights.Updated),
    version: zod_1.z.string(),
    payload: zod_1.z.object({
        surveyId: zod_1.z.string().uuid(),
        weights: zod_1.z.array(zod_1.z.object({
            respondentId: zod_1.z.string().uuid(),
            weight: zod_1.z.number(),
        })),
        pagination: zod_1.z.object({
            pageNumber: zod_1.z.number(),
            totalPages: zod_1.z.number(),
        }),
    }),
});
exports.SurveyWeightsIngestedSchema = zod_1.z.object({
    type: zod_1.z.literal(enums_1.MessageType.SurveyWeights.Ingested),
    version: zod_1.z.string(),
    payload: zod_1.z.object({
        surveyId: zod_1.z.string().uuid(),
        messageGroupId: zod_1.z.string().uuid(),
    }),
});
